<template lang="pug">
    div
        div.dictantFormWrap(v-if="!testuser")
            div.formbg
            div.formgradient
                v-img.budLogo(src="images/bud.png")
                div.dictantUserRegister
                    div.formTitle.mb-3 {{ 'Test_REGISTRACIYA' | localize }}
                    v-form.testUserForm(v-on:submit.prevent="userFormSubmit")
                        v-text-field.userFormField(v-model="user.name" :label="'Test_IMYA' | localize" required solo flat :error-messages="nameErrors" @input="$v.user.name.$touch()" @blur="$v.user.name.$touch()")
                        v-text-field.userFormField(v-model="user.phone" label="Телефон" required solo flat :error-messages="phoneErrors" @input="$v.user.phone.$touch()" @blur="$v.user.phone.$touch()")
                        div.formBtnWrap
                            v-btn.formBtn(type="submit" text color="#fff") {{ 'Test_PROITI_TEST' | localize }}

        

        v-progress-linear(v-if="loading" :indeterminate="true")
        v-card(flat v-if="testuser && usertest && usertest.test")
            v-card-title.noBreakWords 
                div.mainTitle(v-if="!testEnded") {{ 'Test_TITLE' | localize }}
                div.mainTitle(v-if="testEnded")
                    div(v-if="locale == 'ru'") Спасибо! Вы прошли тест по истории удмуртского языка, ваш результат {{ getCorrectCount }} из {{ this.usertest.test.questions.length }}.
                    div(v-if="locale == 'udm'") Тау! Тӥ удмурт кылъя тодон-валандэс эскериды, шонер валэктон сётӥды {{ this.usertest.test.questions.length }} юан пӧлысь {{ getCorrectCount }} юанлы.

            v-card-text(v-if="usertest.test.questions")
                div(v-if="testEnded")

                    div.sertWrap
                        div.taCenter
                            a(:href="pdfPath") Скачать сертификат
                        div.sert
                            pdf(:src="pdfPath")

                    v-row(v-for="question in usertest.test.questions" :key="question.id")    
                        v-col(cols="12")
                            v-card.mb-5.borderOne(outlined)
                                v-card-title.noBreakWords.newRoman.cardHead {{ $showLocalizedField(question.questiontext, locale).text }}
                                v-card-text(v-if="question.variants")
                                    div(v-for="variant in question.variants" :key="variant.id")
                                        div.pd-5(:class="checkAnswer(question,variant)") {{ $showLocalizedField(variant.varianttext, locale).text }}

                    .mb-3(v-if="locale == 'ru'") Количество участников теста {{ usertest.testresult.resultsCount }} человек.
                    .mb-3(v-if="locale == 'udm'") Тодон-валанзэ эскериз {{ usertest.testresult.resultsCount }} мурт.

                div(v-else)
                    .mb-3 Вопрос {{ currentQuestionIndex+1 }} из {{ this.usertest.test.questions.length }}
                    v-card.borderOne(outlined v-if="curentQuestion")
                        v-card-title.noBreakWords.newRoman.cardHead {{ $showLocalizedField(curentQuestion.questiontext, locale).text }}
                        v-card-text(v-if="curentQuestion.variants")
                            v-form.testUserForm(v-on:submit.prevent="saveAnswer(curentQuestion)")
                                v-radio-group(v-model="curentQuestion.answer")
                                    v-radio(v-for="variant in curentQuestion.variants" :key="variant.id" :value="variant" :label="$showLocalizedField(variant.varianttext, locale).text")
                                v-btn.testBtn(type="submit" :disabled="disableBtn(curentQuestion)") Ответить
        
        
</template>


<script>
    import { testsService } from '@/_services'
    import { config } from '@/_helpers'
    import { mapState, mapMutations } from "vuex";
    import localize from "@/filters/localize.filter";

    import { validationMixin } from 'vuelidate'
    import { required, numeric } from 'vuelidate/lib/validators'

    import pdf from 'vue-pdf'

    export default {
        components: {
            pdf
        },
        mixins: [validationMixin],
        validations: {
            user: {
                name: { required },        
                phone: { required, numeric }
            }
        },
        mounted () {
            if (this.testuser) {
                this.usertest = {testuserid:this.testuser.id,testid:this.defaultTestId,test:null,testresult:null}
                this.loadtest()
            }
        },
        computed: {
            ...mapState(['locale']),
            ...mapState('tests',['testuser']),

            nameErrors () {
                const errors = []
                if (!this.$v.user.name.$dirty) return errors
                !this.$v.user.name.required && errors.push('Обязательное поле')
                return errors
            },
            phoneErrors () {
                const errors = []
                if (!this.$v.user.phone.$dirty) return errors
                !this.$v.user.phone.required && errors.push('Обязательное поле')
                var re = /^[0-9]+$/gi
                if (!re.test(this.user.phone)) errors.push('Только цифры')
                return errors
            },
            testEnded(){
                if (this.usertest.test.questions.length == this.usertest.testresult.answers.length) return true
                return false
            },
            curentQuestion(){
                let qq = this.usertest.test.questions[this.currentQuestionIndex]
                return qq
            },
            getCorrectCount(){
                let count = 0
                for (let answer of this.usertest.testresult.answers) {
                    let q = this.usertest.test.questions.find(q => {return q.id == answer.questionid})
                    if (q) {
                        let a = q.variants.find(v => {return v.id == answer.answervariants[0].variantid})
                        if (a && a.isCorrect) count++
                    }
                }
                return count
            }
        },
        methods: {
            ...mapMutations('tests',['setTestuser']),

            loadtest(){
                this.loading = true
                testsService.loadusertest(this.usertest).then(data=>{
                    this.usertest = data
                    this.loading = false
                    this.goToNextQuestion()

                    this.pdfPath = `${config.apiUrl}test/${this.usertest.testid}/sertificat/${this.usertest.testuserid}`
                })
            },

            validateUserForm(){
                this.$v.$touch()
                let isInvalid = this.$v.$invalid
                return isInvalid
            },
            userFormSubmit(){
                if (!this.validateUserForm()){
                    this.$nextTick(() => {
                        testsService.adduser(this.user).then(data=>{
                            this.setTestuser(data)
                            this.usertest = {testuserid:this.testuser.id,testid:this.defaultTestId,test:null,testresult:null}
                            this.loadtest()
                        })
                    })
                }
            },

            disableBtn(question){
                if (!question.answer) return true
                return false
            },

            checkAnswer(question,variant){
                let classes = ''
                if (this.isAnswered(question).variantid == variant.id) {
                    classes = 'answered'
                    if (variant.isCorrect) {
                        classes += ' correct'
                    } else {
                        classes += ' incorrect'
                    }
                } else {
                    if (variant.isCorrect) classes = 'bordered'
                }
                return classes
            },

            isAnswered(question){
                let ans = this.usertest.testresult.answers.find(a => {return a.questionid == question.id})
                if (ans) {
                    if (question.type == 0) return ans.answervariants[0]
                }
                return false
            },

            saveAnswer(question){
               
                let answer = {
                    testresultid:this.usertest.testresult.id,
                    questionid:question.id,
                    answervariants:[
                        {
                            variantid:question.answer.id
                        }
                    ]
                }

                testsService.saveAnswer(answer).then(data=>{
                    if (this.usertest.testresult.answers.length == 0) {
                        this.usertest.testresult.answers.push(data)
                    } else {
                        if (question.type == 0) {
                            let ans = this.usertest.testresult.answers.find(a => {return a.questionid == data.id})
                            if (ans) ans.answervariants[0].variantid = data.answervariants[0].variantid
                            else this.usertest.testresult.answers.push(data)
                        }
                    }
                    this.goToNextQuestion()
                })
            },
            goToNextQuestion(){
                if (this.curentQuestion && this.isAnswered(this.curentQuestion)) {
                    this.currentQuestionIndex++
                    this.goToNextQuestion()
                }
            },
            dropResults(){
                this.user = {name:'',email:'',phone:''}
                this.setTestuser(null)
            }
        },
        watch: {
            locale: function(){
                document.title = localize('Test_TITLE');
            }
        },
        data() {
            return {
                user:{
                    name:'',
                    email:'',
                    phone:''
                },
                loading:false,
                variantLoading:false,
                usertest:null,
                defaultTestId:1,

                currentQuestionIndex:0,

                pdfPath: null
            }
        }
    }
</script>

<style lang="scss" scoped>
    .pd-5{
        padding:5px
    }
    .dictantFormWrap {
        width:100%;
        height: 350px;
        position: relative;
        font-family: Segoe UI;
    }
    .formbg {
        background: url(/images/dictant.jpg) no-repeat center;
        background-size: cover;
        height: 100%;
    }
    .formgradient{
        position: absolute;
        top:0;
        left:0;
        width: 100%;
        height: 100%;
        background:linear-gradient(180deg, rgba(183, 7, 7, 0.15) 99.99%, rgba(255, 255, 255, 0) 100%)
    }
    .budLogo {
        width:35%;
        height:auto;
        margin: 3% 0 0 8%;
    }
    .dictantUserRegister {
        margin:4% 0 0 8%;
        color:#fff;
        width:280px;
    }
    .userFormField {
        font-family: Segoe UI;
        font-style: italic;
    }
    .formBtnWrap {
        position: relative;
    }
    .formBtn {
        background:#FF4646;
        font-family: Segoe UI;
        font-style: italic;
        text-transform: none;
        position: absolute;
        right: 0;
    }
    .answered.correct {
        background: #0f0;
    }
    .answered.incorrect {
        background: #f00;
    }
    .bordered {
        border:1px solid #f0f0f0;
        background: #0ff;
    }
    .noBreakWords {
        word-break: normal !important;
    }
    .mainTitle {
        font-weight: 300;
        font-size: 18px;
    }
    .cardHead {
        font-weight: 300;
        font-size: 23px;
        font-family: Times New Roman !important;
    }
    .borderOne {
        border-radius: 1px !important;
    }
    .testBtn {
        border-radius: 1px !important;
    }
    .sertWrap {
        width:90%;
        max-width:1000px;
        margin: 10px auto;
    }
    .sert {border:3px solid #c0c0c0;}
    @media (min-width:600px) {
        .dictantFormWrap {
            height:400px;
        }
        .budLogo {
            width:20%;
            margin: 4% 0 0 8%;
        }
    }
    @media (min-width:960px) {
        .dictantFormWrap {
            height:500px;
        }
        .budLogo {
            width:20%;
            margin: 4% 0 0 8%;
        }
    }
    @media (min-width:1264px) {
        .dictantFormWrap {
            height:600px;
        }
        .budLogo {
            width:14%;
            margin: 4% 0 0 8%;
        }
    }
    @media (min-width:1904px) {
        .dictantFormWrap {
            height:656px;
        }
        .budLogo {
            width:14%;
            margin: 4% 0 0 8%;
        }
    }
</style>